/* eslint-disable no-unused-vars */
import { makeAutoObservable } from "mobx";
import ApiStore from "./ApiStore";
import {
  Group,
  GroupAddition,
  Position,
  Property,
} from "../../api/ApplicationApi";

class ApplicationStore {
  private _api: ApiStore;
  isLoadingProperty: boolean = false;
  selectedPropertyId: number;
  propertyList: Property[] = [];
  groupList: Group[] = [];
  isLoadGroups: boolean = false;

  additionGroup: GroupAddition[] = [];
  additionGroupName: string = "";

  propertyId: any = {};
  groupSelectValue: string = "";
  comiteeId: string | null = null;
  comiteeName: string = "";
  propertyName: string = "";
  propertyInputText: string = "";
  selectedProperty: any = {};
  positions: Position[] = [];
  showAddCommiteeGroupModal: boolean = false;
  isShowVerbiage: boolean = false;
  commityMemberPositions: Array<any> = [];
  displaySendFinancials: boolean = false;
  prevSelected: any = {};
  isAuthorization: boolean = true;
  isFinCen: boolean = false;
  constructor(api: ApiStore, isFinCen: boolean) {
    makeAutoObservable(this);
    this._api = api;
    this.isFinCen = isFinCen;
    console.log("isFinCen: ", isFinCen);
  }

  loadPositions(): void {
    this._api.api
      .getPositionsAsync()
      .then((res) => {
        if (res.data) {
          this.positions = res.data.positions as Position[];
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  async loadPropertyList(): Promise<void> {
    await this._api.api
      .getPropertyListAsync()
      .then((response) => {
        this.propertyList = response.data?.properties;
      })
      .catch((err) => {
        console.log(err);
        if (err.response.status === 401) {
          this.isAuthorization = false;
        }
      });
  }

  async loadGroupListById(id: string, newGroupName: string): Promise<void> {
    await this._api.api
      .getGroupsByPropertyIdAsync(id)
      .then((response) => {
        this.groupList = response.data.groups;
        if (newGroupName && newGroupName !== "") {
          const groupSelected = response.data.groups.find(function (group) {
            return group.name === newGroupName;
          });
          if (groupSelected) {
            this.comiteeId = groupSelected.id.toString();
            this.comiteeName = groupSelected.name;
            this.displaySendFinancials = groupSelected.displaySendFinancials;
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
    this.isLoadGroups = false;
  }

  setIsLoading(status: boolean): void {
    this.isLoadingProperty = status;
  }

  setAdditionGroupName(groupe: string): void {
    console.log(groupe);
    this.additionGroupName = groupe;
  }

  setSelectedProperty(propertyId: number): void {
    this.selectedPropertyId = propertyId;
  }
  showAddGroupModal(): void {
    this.showAddCommiteeGroupModal = true;
  }
  hideAddGroupModal(): void {
    this.showAddCommiteeGroupModal = false;
  }
  async saveGroupModal(): Promise<void> {
    const searchGroupe = this.additionGroup.find(
      (_) => _.availableGroup === this.additionGroupName
    );
    if (searchGroupe) {
      console.log(searchGroupe);
      const data = new FormData();
      data.append("companyKey", this.propertyId);
      data.append("groupType", searchGroupe.groupType.toString());
      data.append("committeeName", searchGroupe.availableGroup);
      await this._api.api
        .addCommitteeAsync(data)
        .then(async (res) => {
          console.log(res);
          await this.loadGroupListById(
            this.propertyId.toString(),
            this.additionGroupName
          )
            .then((res1) => {
              console.log(res1);
              this.setAdditionGroupName("");
            })
            .catch(console.error);
        })
        .catch(console.error);
    }
  }
  async changeProperty(selected: Property | undefined): Promise<void> {
    this.additionGroup = [];
    this.comiteeName = "";
    if (selected && selected.id) {
      this.setSelectedProperty(selected.id);
      this.propertyInputText = selected.name;
      this.propertyName = selected.name + " (" + selected.id + ")";
      this.propertyId = selected.id;
      this.groupList = [];
      this.isLoadGroups = true;
      this.comiteeId = null;
      this.selectedProperty = selected;
      this.prevSelected = selected;
      this.isShowVerbiage = false;
      await this.loadGroupListById(selected.id.toString(), selected.name).catch(
        console.log
      );
      await this._api.api
        .getGroupAdditionsAsync(selected.id.toString())
        .then((res) => {
          this.additionGroup = res.data.groups;
        })
        .catch(console.error);
    } else {
      this.isShowVerbiage = false;
      this.propertyInputText = "";
      this.selectedProperty = null;
    }
  }

  async changeGroup(selected: Group | undefined): Promise<void> {
    if (selected?.name === "Architectural Review Committee" ||
        selected?.name === "Design Review Committee"
    ) {
      this.isShowVerbiage = true;
    } else {
      this.isShowVerbiage = false;
    }
    const groupSelected = this.groupList.find(
      (group) => group.id === selected?.id
    );
    console.log("groupSelected");
    console.log(JSON.stringify(groupSelected));
    console.log(selected);

    if (groupSelected) {
      console.log(groupSelected.id.toString());

      this.groupSelectValue = groupSelected.name;

      this.comiteeId = groupSelected.id.toString();
      this.comiteeName = groupSelected.name;
      this.displaySendFinancials = groupSelected.displaySendFinancials;
    }
  }
}
export default ApplicationStore;